/** @jsxImportSource @emotion/react */
import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";

import { useGetAppFooterStyles } from "./index.styles";
import AppBar from "../../components/AppBar";
import { useGetNavItems } from "../../pages/Home/appbarNav";

const AppFooter = () => {
  const classes = useGetAppFooterStyles();

  return (
    <>
      <AppBar navItems={useGetNavItems({}).navItems} pageTitle="Support" />
      <div css={classes.wrapper}>
        <div css={classes.cardsContainer}>
          {/* Get in Touch Card */}
          <div css={classes.glassCard}>
            <h3 css={classes.cardTitle}>
              <EmailOutlinedIcon css={classes.titleIcon} />
              Get in touch
            </h3>
            <p css={classes.cardSubtitle}>Email</p>
            <p css={classes.cardText}>supports@moneymails.com</p>
            <p css={classes.cardText}>1 (453) 234 5611</p>
          </div>

          {/* Social Media Card */}
          <div css={classes.glassCard}>
            <h3 css={classes.cardTitle}>
              <ShareOutlinedIcon css={classes.titleIcon} />
              Social Media
            </h3>
            <p css={classes.cardText}>Follow us on our social channels</p>
            <div css={classes.iconsContainer}>
              <FacebookIcon />
              <InstagramIcon />
              <TwitterIcon />
            </div>
          </div>

          {/* Where We Are Card */}
          <div css={classes.glassCard}>
            <h3 css={classes.cardTitle}>
              <PlaceOutlinedIcon css={classes.titleIcon} />
              Where we are
            </h3>
            <p css={classes.cardSubtitle}>Address</p>
            <p css={classes.cardText}>Money mail offices, Middesborough Road</p>
            <p css={classes.cardText}>Middesborough, TS6 6004</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppFooter;
